import React, { useEffect, useState } from "react";
import axios from "axios";

// ⭐ Your navbar & footer imports — use EXACT file paths
import Navbar from "../DashBoard/Navbar";
import Footer from "../DashBoard/Footer";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await axios.get("https://hrgf.salepatner.com/api/orders/", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrders(res.data);
    } catch (err) {
      console.log("Error fetching orders:", err);
    }
  };

  // Cancel Order
  const cancelOrder = async (id) => {
    if (!window.confirm("Are you sure you want to cancel this order?")) return;

    try {
      await axios.post(
        `https://hrgf.salepatner.com/api/cancel-order/`,
        { order_id: id },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      fetchOrders();
    } catch (err) {
      console.log("Cancel Error:", err);
    }
  };

  return (
    <>
  <Navbar />

  <div className="bg-gray-100 min-h-screen pt-6">

    {/* FULL WIDTH CONTAINER LIKE FLIPKART */}
    <div className="w-full flex max-w-[1500px] mx-auto px-6 gap-6">

      {/* LEFT SIDEBAR — FULL LEFT ATTACHED */}
      <div className="w-[260px] bg-white rounded-lg border shadow-sm p-5 h-max sticky top-24">

  <h2 className="text-xl font-semibold mb-4">Filters</h2>

  {/* ORDER STATUS */}
  <div className="mb-5 pb-4 border-b">
    <h3 className="text-xs font-semibold text-gray-700 mb-3">ORDER STATUS</h3>

    <label className="flex items-center gap-3 text-gray-700 mb-3 text-sm cursor-pointer">
      <input type="checkbox" className="w-4 h-4" />
      On the way
    </label>

    <label className="flex items-center gap-3 text-gray-700 mb-3 text-sm cursor-pointer">
      <input type="checkbox" className="w-4 h-4" />
      Delivered
    </label>

    <label className="flex items-center gap-3 text-gray-700 mb-3 text-sm cursor-pointer">
      <input type="checkbox" className="w-4 h-4" />
      Cancelled
    </label>

    <label className="flex items-center gap-3 text-gray-700 text-sm cursor-pointer">
      <input type="checkbox" className="w-4 h-4" />
      Returned
    </label>
  </div>

  {/* ORDER TIME
  <div>
    <h3 className="text-xs font-semibold text-gray-700 mb-3">ORDER TIME</h3>

    <label className="flex items-center gap-3 text-gray-700 mb-3 text-sm cursor-pointer">
      <input type="checkbox" className="w-4 h-4" />
      Last 30 days
    </label>

    <label className="flex items-center gap-3 text-gray-700 mb-3 text-sm cursor-pointer">
      <input type="checkbox" className="w-4 h-4" />
      2024
    </label>

    <label className="flex items-center gap-3 text-gray-700 mb-3 text-sm cursor-pointer">
      <input type="checkbox" className="w-4 h-4" />
      2023
    </label>

    <label className="flex items-center gap-3 text-gray-700 text-sm cursor-pointer">
      <input type="checkbox" className="w-4 h-4" />
      Older
    </label>
  </div> */}

</div>


      {/* RIGHT CONTENT AREA — FULL WIDTH LIKE FLIPKART */}
      <div className="flex-1">

        {/* SEARCH BAR */}
        <div className="flex mb-6 w-full">
          <input
            type="text"
            placeholder="Search your orders here"
            className="flex-1 border rounded-l-lg px-4 py-2 focus:outline-blue-600"
          />
          <button className="bg-blue-600 text-white px-6 rounded-r-lg">
            Search Orders
          </button>
        </div>

        {/* ORDERS LIST */}
        {orders.length === 0 ? (
          <div className="text-center text-gray-600 mt-14 text-lg">
            No Orders Found
          </div>
        ) : (
          orders.map((order) => (
            <div
              key={order.id}
              className="bg-white w-full p-6 rounded-lg shadow-md border mb-6"
            >
              {/* HEADER */}
              <div className="flex justify-between items-center mb-3">
                {/* <p className="text-sm text-gray-500">
                  Order ID: <span className="font-semibold">{order.order_id}</span>
                </p> */}

                <span
                  className={`text-sm font-semibold flex items-center ${
                    order.status === "SUCCESS"
                      ? "text-green-600"
                      : order.status === "CANCELLED"
                      ? "text-red-600"
                      : "text-orange-600"
                  }`}
                >
                  ● {order.status}
                </span>
              </div>

              {/* ITEMS */}
              {order.items.map((item, idx) => (
                <div
                  key={idx}
                  className="flex gap-4 py-4 border-b last:border-none"
                >
                  <img
                    src={item.product.image}
                    alt=""
                    className="w-24 h-24 rounded-md border object-cover"
                  />

                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-800">
                      {item.product.title}
                    </h3>

                    <p className="text-sm text-gray-600">Qty: {item.quantity}</p>
                    <p className="font-semibold text-gray-900 mt-1">
                      ₹{item.price}
                    </p>
                  </div>
                </div>
              ))}

              {/* FOOTER */}
              <div className="flex justify-between items-center pt-4">
                <p className="text-sm text-gray-600">
                  Ordered On: {new Date(order.created_at).toLocaleDateString()}
                </p>

                <p className="font-bold text-lg">
                  Total: ₹{order.total_amount}
                </p>
              </div>

              {/* CANCEL BUTTON */}
              {order.status === "SUCCESS" && (
                <div className="text-right mt-3">
                  <button
                    onClick={() => cancelOrder(order.order_id)}
                    className="bg-red-500 hover:bg-red-600 text-white text-sm px-4 py-2 rounded-lg"
                  >
                    Cancel Order
                  </button>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  </div>

  <Footer />
</>

  );
};

export default Orders;
